import { render, staticRenderFns } from "./CompanyAddress.vue?vue&type=template&id=6171b12c&scoped=true"
import script from "./CompanyAddress.vue?vue&type=script&lang=js"
export * from "./CompanyAddress.vue?vue&type=script&lang=js"
import style0 from "./CompanyAddress.vue?vue&type=style&index=0&id=6171b12c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171b12c",
  null
  
)

export default component.exports